import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import LeftSidebarRouter from "./components/left-sidebar-router";
import $ from "jquery";

// import RedyCRMRestAPI from 'redycrm-restapi-js/src/react-autoload';

// var RedyCRMRestAPI = require('redycrm-restapi-js/src/react-autoload');

// var mysupertest=  new RedyCRMRestAPI.CRMInstance();

///////////////////////
// console.log(mysupertest);
// console.log(RedyCRMRestAPI);

// var RedyCRMRestAPIClient = require('./RedyCRMRestAPI');
// import RedyCRMRestAPIClient from './RedyCRMRestAPI';

// var RedyCRMRestAPIClient = {};
// console.log(RedyCRMRestAPIClient);
// console.log('hello world');





global.mainDomainName = '/api_http/';


ReactDOM.render(<LeftSidebarRouter/>, document.getElementById('left-sidebar'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js